export const enumStatus: Record<string, string> = {
  R: 'Reprovada',
  S: 'Aprovada',
  A: 'Em Aprovação',
  P: 'Pendente',
};

export interface iMaterial {
  id: number;
  orcamentoId?: number;
  orcamentoMaterialId?: number;
  propostaMaterialAvulsoId?: number;
  status: string;
  descricao: string;
  descricaoAprovacao: string;
  perfil: {
    id: number;
    nome: string;
  };
  material: {
    id: number;
    codigoSap: string;
    descricao: string;
    tipoItem: string;
  };
  orcamentoMaterial: {
    quantidade: number;
  };
  orcamento: {
    id: number;
    codigoOportunidadeDomsge: string;
    pessoa: {
      codigoDomsge: string;
      razaoSocial: string;
    };
  };
  usuarioSolicitante: {
    id: number;
    username: string;
    nome: string;
  };
  usuarioAprovacao?: {
    id: number;
    username: string;
    nome: string;
  };
  MaterialAcessorioAnexos: {
    id: number;
    arquivo: {
      nome: string;
      url: string;
      tipo: string;
      tamanho: number;
    };
  }[];
}

export interface iMaterialLista {
  id: number;
  orcamentoId?: number;
  orcamentoMaterialId?: number;
  propostaMaterialAvulsoId?: number;
  status: string;
  statusCor: string;
  statusNome: string;
  descricao: string;
  descricaoAprovacao: string;
  perfil: string;
  material: string;
  usuarioAprovacao?: string;
  usuarioSolicitante: string;
  codigoOportunidadeDomsge: string;
  clienteCodigo: string;
  clienteNome: string;
  quantidade: number;
}
